import React from 'react';

import ListGroup from 'react-bootstrap/ListGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {dateTimeToDE, dateToDE} from '../util/Util.js';
import {makeButton} from "../util/Analyses";


const Archive = ({
	client,
	selectAnalysis,
	selectKairogramm,
}) => {
	const entries = [];

	// TODO move creation of show/download buttons to analysis-central place

	// functions for entry creation
	const makeAnalysisEntry = ({ id, label, kairosDate, creationDate, creator, onSelect, download }) => {
		const button = makeButton(download, onSelect);

		return (
			<ListGroup.Item key = {id}>
				<Container className = {'m-0'}>
					<Row className = {'align-items-center'}>
						<Col>
							{`${label} zum Kairos-Datum ${dateToDE(kairosDate)} (erstellt: ${dateTimeToDE(creationDate)} von ${creator})`}
						</Col>
						<Col>
							{button}
						</Col>
					</Row>
				</Container>
			</ListGroup.Item>
		);
	};

	// kairogramme
	client.kairogramme.forEach(a => entries.push({
		entry: {
			id: a.id,
			label: 'Kairogramm',
			kairosDate: a.kairosDate,
			creationDate: a.creationDate,
			creator : a.kairosUserName,
			onSelect : () => selectKairogramm(a.id),
		},
		func: makeAnalysisEntry,
	}));

	// standard einzelanalysen
	client.standardEinzelanalysen.forEach(a => entries.push({
		entry: {
			id: a.id,
			label: 'Standard Kairos-Einzelanalyse',
			kairosDate: a.kairosDate,
			creationDate: a.creationDate,
			creator : a.kairosUserName,
			onSelect : selectAnalysis('STANDARD_EINZEL_KAIROSANALYSE', a.id),
			download: true,
		},
		func: makeAnalysisEntry,
	}));

	// premium einzelanalysen
	client.premiumEinzelKairosanalysen.forEach(a => entries.push({
		entry: {
			id: a.id,
			label: 'Premium Kairos-Einzelanalyse',
			kairosDate: a.kairosDate,
			creationDate: a.creationDate,
			creator : a.kairosUserName,
			onSelect : selectAnalysis('PREMIUM_EINZEL_KAIROSANALYSE', a.id),
			download: true,
		},
		func: makeAnalysisEntry,
	}));

	// persoenliche kairosanalysen
	client.persoenlicheKairosanalysen.forEach(a => entries.push({
		entry: {
			id: a.id,
			label: 'Persönliche Kairosanalyse',
			kairosDate: a.kairosDate,
			creationDate: a.creationDate,
			creator : a.kairosUserName,
			onSelect : selectAnalysis('PERSOENLICHE_KAIROSANALYSE', a.id),
			download: true,
		},
		func: makeAnalysisEntry,
	}));

	// standortbestimmung
	client.standortBestimmungen.forEach(a => entries.push({
		entry: {
			id: a.id,
			label: 'Standort-Bestimmung',
			kairosDate: a.kairosDate,
			creationDate: a.creationDate,
			creator : a.kairosUserName,
			onSelect : selectAnalysis('STANDORTBESTIMMUNG', a.id),
			download: true,
		},
		func: makeAnalysisEntry,
	}));

	// team kairosanalysen
	client.teamKairosanalysen.forEach(a => entries.push({
		entry: {
			id: a.id,
			label: 'Team Kairosanalyse',
			kairosDate: a.kairosDate,
			creationDate: a.creationDate,
			creator : a.kairosUserName,
			onSelect : selectAnalysis('TEAM_KAIROSANALYSE', a.id),
			download: true,
		},
		func: makeAnalysisEntry,
	}));

	// kalender: 3 parts with separate download links
	const makeKalenderEntry = ({ id, kairosDate, creationDate, creator }) => {
		const calendarButton = (
			<a
				href = {selectAnalysis('KAIROS_KALENDER', id, 'CALENDAR')}
				className = {'btn btn-success'}
				role = {'button'}>
				{'Abrufen'}
			</a>
		);

		const accompanyingDocButton = (
			<a
				href = {selectAnalysis('KAIROS_KALENDER', id, 'ACCOMPANYING_DOC')}
				className = {'btn btn-success'}
				role = {'button'}>
				{'Abrufen'}
			</a>
		);

		const icalButton = (
			<a
				href = {selectAnalysis('KAIROS_KALENDER', id, 'ICAL')}
				className = {'btn btn-success'}
				role = {'button'}>
				{'Abrufen'}
			</a>
		);

		return (
			<ListGroup.Item key = {id}>
				<Container className = {'m-0'}>
					<Row className = {'align-items-center'}>
						<Col>
							{`Kalender zum Kairos-Datum ${dateToDE(kairosDate)} erstellt am ${dateToDE(creationDate)} von ${creator})`}
						</Col>
						<Col>
							{calendarButton}
						</Col>
					</Row>
					<Row className = {'align-items-center'}>
						<Col>
							{`Begleitdokument zum Kairos-Datum ${dateToDE(kairosDate)} (erstellt am ${dateToDE(creationDate)} von ${creator})`}
						</Col>
						<Col>
							{accompanyingDocButton}
						</Col>
					</Row>
					<Row className = {'align-items-center'}>
						<Col>
							{`ical zum Kairos-Datum ${dateToDE(kairosDate)} (erstellt am ${dateToDE(creationDate)} von ${creator})`}
						</Col>
						<Col>
							{icalButton}
						</Col>
					</Row>
				</Container>
			</ListGroup.Item>
		);
	};

	// kairos-kalender
	client.kairosKalender.forEach(a => entries.push({
		entry: {
			id: a.id,
			kairosDate: a.kairosDate,
			creationDate: a.creationDate,
			creator: a.kairosUserName,
		},
		func: makeKalenderEntry,
	}));


	// list all products in order of creation

	const byCreationDate = entries
		.sort((a1, a2) => a1.entry.creationDate > a2.entry.creationDate ? -1 : 1)
		.map(({entry, func}) => func(entry));


	// render
	return (
		<ListGroup>
			{byCreationDate}
		</ListGroup>
	);
}

export default Archive;
